import { render } from "./LostWave.vue?vue&type=template&id=29fa0e5e"
import script from "./LostWave.vue?vue&type=script&lang=js"
export * from "./LostWave.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__